<template>
  <v-container fill-height>
    <v-layout row justify-center align-center>
      <v-flex xs12 sm12 md6>
        <form-login></form-login>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import formLogin from "../components/FormLogin";

export default {
  name: "Login",
  components: {
    formLogin,
  },
};
</script>
